import { render, staticRenderFns } from "./InvestmentAllocationPieChart.vue?vue&type=template&id=da194030"
import script from "./InvestmentAllocationPieChart.vue?vue&type=script&lang=js"
export * from "./InvestmentAllocationPieChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports